export interface ViewNav {
    title: string;
    viewTag: string;
    icon: string;
    enabled: boolean;
    class?: string | null;
}
